import gql from 'graphql-tag';

export const SETTINGS_UPDATE = gql`
  mutation ($id: ID!, $data: JSON!) {
    settingsUpdate(id: $id, data: $data) {
      id
      scope
      scope_id
      data_filled
      data_scoped
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/settings/update.js